<div container>
  <div class="section4__container card card--purple-top d-flex flex-column flex-lg-row align-items-center justify-content-center">
    <div class="section4__image">
      <picture [data]=" {
        image: 'benefits-of-knowing/section4-image',
        webp: true,
        altext: 'An envelope',
        format: '',
        width: '141',
        height: '82',
        mobile: false,
        classes: 'img-fluid',
      }"></picture>
    </div>
    <div class="section4__text">
      <h3 class="mb-0 text-center text-lg-start">Get updates and more information about screening and treatment.</h3>
    </div>
    <div class="section4__button" global-button [buttonData]="{
      buttonLabel: 'Sign up to stay connected',
      buttonUrl: '/get-updates/',
      openInNewTab: false,
      buttonIcon: 'right-icon'
    }"></div>
  </div>
</div>